module.exports = __webpack_public_path__ + "static/media/newsPoint02.0f067548.jpeg";